import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-background-50 rounded-lg">
                <i className="ri-compass-3-line text-primary-500 text-lg"></i>
              </span>
              <span className="text-xl font-bold font-heading text-background-50">91网址</span>
            </div>
            <p className="text-sm text-background-50/80 leading-relaxed">
              一站式网址导航平台，汇聚海量精选优质网址资源，帮助您快速找到所需网站，告别繁琐搜索。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/life" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">分类导航</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/life" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">生活服务</Link>
              <Link to="/category/tools" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">工具资源</Link>
              <Link to="/category/entertainment" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">娱乐休闲</Link>
              <Link to="/category/education" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">学习教育</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-3 text-sm text-background-50/70">
              <div className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-background-50/70"></i>
                </span>
                <span>contact@91wangzhi.com</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-background-50/70"></i>
                </span>
                <span>91网址官方</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-background-50/70"></i>
                </span>
                <span>中国 · 北京</span>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60">
            &copy; {currentYear} 91网址 - 精选网址导航与资源汇聚平台 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}